import { z } from 'zod/v4';

export type RiskManagementNotificationFrequency = z.infer<typeof RiskManagementNotificationFrequencyRuntype>;
export const RiskManagementNotificationFrequencyRuntype = z.enum(['daily', 'weekly', 'monthly']);

export type RiskManagementAlertType = z.infer<typeof RiskManagementAlertTypeRuntype>;
export const RiskManagementAlertTypeRuntype = z.enum(['critical', 'warning', 'review']);

export type RiskManagementNotification = z.infer<typeof RiskManagementNotificationRuntype>;
export const RiskManagementNotificationRuntype = z.object({
    id: z.uuid(),
    frequency: RiskManagementNotificationFrequencyRuntype.nullable(),
    notify_via_email: z.boolean(),
    notify_via_in_app_notifications: z.boolean(),
    notify_for_library: z.boolean(),
    notify_for_assemblies: z.boolean(),
    notify_for_critical: z.boolean(),
    notify_for_warning: z.boolean(),
    notify_for_review: z.boolean(),
    assembly_ids: z.array(z.uuid()),
    user_id: z.uuid(),
    last_notified_at: z.iso.datetime().nullable(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
});

export type RiskManagementNotificationRequest = z.infer<typeof RiskManagementNotificationRequestRuntype>;
export const RiskManagementNotificationRequestRuntype = z.object({
    frequency: RiskManagementNotificationFrequencyRuntype.nullable(),
    notify_via_email: z.boolean(),
    notify_via_in_app_notifications: z.boolean(),
    notify_for_library: z.boolean(),
    notify_for_assemblies: z.boolean(),
    notify_for_critical: z.boolean(),
    notify_for_warning: z.boolean(),
    notify_for_review: z.boolean(),
    assembly_ids: z.array(z.uuid()),
});
